// extracted by mini-css-extract-plugin
export default {"scaleContainer":"ScaleTile_scaleContainer__dMpTn","icon":"ScaleTile_icon__aUxFg","title":"ScaleTile_title__br7e+"};